import { axiosInstance } from "../../../../Services";

export const fetchCardAttachments = async (cardId, limit = 10, page = 1) => {
  try {
    const res = await axiosInstance.get(
      `/mmhboard/cards/attachment/${cardId}?limit=${limit}&page=${page}`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const uploadCardAttachment = async (cardId, formData) => {
  try {
    const res = await axiosInstance.post(
      `/mmhboard/cards/attachment/${cardId}`,
      formData,
    );
    return res;
  } catch (error) {
    throw error;
  }
};
